import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { libertyPaymentsApi } from "../api";

export const LanguageSwitcher = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  //
  const handleChangeLanguage = useCallback(() => {
    let language = i18n.language;
    language = language === "ka" ? "en-US" : "ka";
    i18n.changeLanguage(language);
    localStorage.setItem("LibertyPaymentsLanguage", language);
    dispatch(
      libertyPaymentsApi.util.invalidateTags([
        "FAQ",
        "Activities",
        "PosTerminalTypes",
        "Regions",
      ])
    );
  }, [i18n, dispatch]);

  useEffect(() => {
    document.title = i18n.t("Common.Title");
  }, [i18n.language]);

  return (
    <span className={className} onClick={handleChangeLanguage}>
      {i18n.t(`Common.${i18n.language === "ka" ? "en-US" : "KA"}`)}
    </span>
  );
};
